import { useLayoutEffect } from 'react'

import { ChatWindow } from 'components/Organisms/Message/ChatWindow'
import { useState } from 'react'
import { RightPanel } from './RightPanel/RightPanel'
import { RightHeader } from './RightHeader/RightHeader'
import { Chat } from './Chat/Chat'
import { TogRightButton } from './TogRightButton/TogRightButton'
import { TogRightContent } from './TogRightContent/TogRightContent'
import { Gameplay } from './Gameplay/Gameplay'
import { Menu } from './Menu/Menu'
import { WalletManager } from './Wallet/WalletManager/WalletManager'
import { useLayoutV3State } from 'hooks/useLayoutV3State'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

import { useUrlQueryParam } from 'utils/hooks/useUrlQueryParam'
import { ChatHeaderMenu } from './Chat/ChatHeaderMenu/ChatHeaderMenu'
import { ChatHeaderMenuItem } from './Chat/ChatHeaderMenu/ChatHeaderMenuItem/ChatHeaderMenuItem'
import { MarketTimeline } from './Chat/MarketTimeline'
import { findKeyByValue } from 'utils/arraysObjects'
import { PageWrapperCSS } from './PageWrapperCSS.styled'
import { LeftPanelApp } from 'components/Organisms/LeftPanelApp'
import { useReferralCode } from 'hooks/useReferralCode'
import { MobileWIP } from 'components/MobileWIP'
import { useParams } from 'react-router-dom'
import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'

const chatHeaderMenu = {
  ALL: 'All',
  DMUser: '@DMUser',
}

export const GamePageV3 = ({ contentProp }) => {
  // const { setCurrentGame } = useLayoutV3State()

  //ACZ: start - this part need to refactor
  const { content } = useParams()
  const { setCurrentGame, hideRightPanel, isOpenRightPanel, setOpenRightPanel } = useLayoutV3State()
  const [selectedChatHeaderMenuItem, setSelectedChatHeaderMenuItem] = useState(chatHeaderMenu.ALL)
  const toggleRightPanel = () => {
    setOpenRightPanel(!isOpenRightPanel)
  }

  useLayoutEffect(() => {
    if (content === 'private_presale') return
    if (content === CONTENT_TYPES.PUBLIC_PRESALE) return
    if (!content && !contentProp) return
    setCurrentGame(content || contentProp)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content, contentProp])

  // look for referralCode
  useReferralCode()

  // URL Query params checker
  const gameSelection = useUrlQueryParam('gametype')
  useLayoutEffect(() => {
    if (gameSelection) {
      const validGameType = CONTENT_TYPES[findKeyByValue(CONTENT_TYPES, gameSelection)]
      if (validGameType) setCurrentGame(validGameType, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <PageWrapperCSS id='page_wrapper'>
        <div id='main'>
          <div className='content'>
            <div id='game_main_area'>
              <LeftPanelApp />
              <Gameplay />
              {/*ACZ: start - this part needs to be refactored  */}
              <>
                <RightHeader>
                  <WalletManager />
                  <Menu />
                </RightHeader>
                {!hideRightPanel && (
                  <RightPanel>
                    <Chat isOpen={isOpenRightPanel}>
                      <ChatHeaderMenu>
                        <TogRightButton onClick={() => toggleRightPanel()} />
                        <ChatHeaderMenuItem
                          selected={selectedChatHeaderMenuItem === chatHeaderMenu.ALL}
                          onClick={() => setSelectedChatHeaderMenuItem(chatHeaderMenu.ALL)}
                        >
                          Social Feed
                        </ChatHeaderMenuItem>
                        <ChatHeaderMenuItem
                          selected={selectedChatHeaderMenuItem === chatHeaderMenu.DMUser}
                          onClick={() => setSelectedChatHeaderMenuItem(chatHeaderMenu.DMUser)}
                        >
                          Market Timeline
                        </ChatHeaderMenuItem>
                      </ChatHeaderMenu>
                      <TogRightContent isOpen={isOpenRightPanel}>
                        {selectedChatHeaderMenuItem === chatHeaderMenu.ALL && <ChatWindow isOpen={isOpenRightPanel} />}
                        {selectedChatHeaderMenuItem === chatHeaderMenu.DMUser && (
                          <MarketTimeline isOpen={isOpenRightPanel} />
                        )}
                      </TogRightContent>
                    </Chat>
                  </RightPanel>
                )}
              </>
              {/*ACZ: end - this part needs to be refactored  */}
            </div>
          </div>
        </div>
      </PageWrapperCSS>
      <ContentSwitcherByState
        activeState={content || contentProp}
        stateObject={{
          [CONTENT_TYPES.YOLO_TOKEN]: null,
          [CONTENT_TYPES.ACHIEVEMENT]: null,
          [CONTENT_TYPES.PRIVATE_PRESALE]: null,
          [CONTENT_TYPES.PUBLIC_PRESALE]: null,
          default: <MobileWIP />,
        }}
      />
    </>
  )
}
